<template>
    <div class="col-12">
      <div class="search-padd">
        <form v-on:submit.prevent>
          <div class="scraping_header"></div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-xs-12 override-padding">
            <div class="col-md-8 float-left override-padding" style="padding-right: 10px;">
                <label class="col-12 override-padding">Note:</label>
                <textarea
                    v-model="notes"
                    placeholder=""
                    class="notes_textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
                    @keyup='charCount()'
                    v-validate="'required'"
                    name="notes"
                    maxlength="1000">
                    </textarea>
                <div class="text-align-right">Characters left: {{ totalcharacter }}</div>
                <div v-if="verrors.firstByRule('notes', 'required')" class="margin-bottom-5 validate-warning-msg">Notes is required</div>
            </div>
            <div class="col-md-2 float-left override-padding">
                <label class="col-12 override-padding">Follow Up:</label>
                <b-form-select
                    class="col-md-12 input-height-30 padding-lr-5"
                    v-model="follow_reason"
                    :options="follow_reason_options"
                    >
                    </b-form-select>
                <div style="clear: both;" class="margin-bottom-10"></div>
                <date-picker
                  v-model="follow_date"
                  :disabled-date="notBeforeToday"
                  format="MM/DD/YYYY"
                  v-bind:clearable="false"
                  input-class="col-md-12 input-height-30 padding-lr-5"
                  >
                  <template v-slot:icon-calendar>
                    <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  </template>
                </date-picker>
                <div style="clear: both;" class="margin-bottom-10"></div>
                <div class="col-xs-12 override-padding">
                  <div class="col-md-4 float-left override-padding">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5"
                        v-model="time_hours"
                        :options="time_hours_options"
                        >
                        </b-form-select>
                  </div>
                  <div class="col-md-4 float-left override-padding">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5"
                        v-model="time_minutes"
                        :options="time_minutes_options"
                        >
                        </b-form-select>
                  </div>
                  <div class="col-md-4 float-left override-padding">
                    <b-form-select
                        class="col-md-12 input-height-30 padding-lr-5"
                        v-model="session"
                        :options="session_options"
                        >
                        </b-form-select>
                  </div>
                </div>
            </div>
            <div class="col-md-2 float-right override-padding text-align-right">
              <div style="clear: both;" class="margin-bottom-20"></div>
              <div class="col-md-12 override-padding " style="padding-left: 0">
                <button
                    @click="print_router_redirect()"
                    class="button-width btn btn-red btn-md input-height-15"
                    >Print Notes</button>
                <div style="clear: both;margin-bottom: 60px"></div>
                <button
                    @click="saveNotes()"
                    class="button-width btn btn-red btn-md input-height-15"
                    >Save Notes</button>
              </div>

            </div>
          </div>

        </form>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="notes">
          <div class="col-12 override-padding notes-display" v-for="(note, index) in display_notes">
            <div class="col-12" style="color: #000;">
              {{ note.notes }}
            </div>
            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-md-5 float-left override-padding" style="padding-right: 10px;">
              <div class="col-12 red-color" style="padding-left: 30px;">
                - <i>{{ note.created_by }} @ {{ createdDate(note.createdAt) }}</i>
              </div>
            </div>
            <div v-if="note.followUpReason" class="col-md-7 float-right override-padding text-align-right" style="bottom: 0;">
              <div class="col-12">
                <b>Follow Up:</b> {{ FollowDate(note.followUpDate) }}  {{ note.followUpReason }}
                <span
                  v-if="note.status == 'PENDING'"
                  class="red-color cursor-pointer"
                  @click="updateNotes(note.id)"
                  >Mark Complete</span>
                <span
                  v-if="note.status == 'COMPLETED'"
                  class="bold">Completed</span>
              </div>
            </div>
            <div style="clear: both;"></div>
            <hr>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import DeleteModal from '../shared/delete_modal_alert.vue';
import { Validator } from "vee-validate";
import ValidationModal from '../shared/validation_modal_alert.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
      props: ['accountId'],
      data() {
        return {
          isInfoModalVisible: false,
          validationMessage: '',
          notes: '',
          follow_reason: '',
          follow_reason_options: [
            { value: '', text: 'No Follow Up' },
            { value: 'Sales/Marketing', text: 'Sales/Marketing' },
            { value: 'Relationship Building', text: 'Relationship Building' },
            { value: 'Technical', text: 'Technical' },
            { value: 'Support', text: 'Support' },
            { value: 'Other', text: 'Other' },
          ],
          time_hours: '09',
          time_hours_options: [
            { value: '01', text: '01' },
            { value: '02', text: '02' },
            { value: '03', text: '03' },
            { value: '04', text: '04' },
            { value: '05', text: '05' },
            { value: '06', text: '06' },
            { value: '07', text: '07' },
            { value: '08', text: '08' },
            { value: '09', text: '09' },
            { value: '10', text: '10' },
            { value: '11', text: '11' },
            { value: '12', text: '12' },
          ],
          time_minutes: '00',
          time_minutes_options: [
            { value: '00', text: '00' },
            { value: '05', text: '05' },
            { value: '10', text: '10' },
            { value: '15', text: '15' },
            { value: '20', text: '20' },
            { value: '25', text: '25' },
            { value: '30', text: '30' },
            { value: '35', text: '35' },
            { value: '40', text: '40' },
            { value: '45', text: '45' },
            { value: '50', text: '50' },
            { value: '55', text: '55' },
          ],
          session: 'AM',
          session_options: [
            { value: 'AM', text: 'AM' },
            { value: 'PM', text: 'PM' },
          ],
          totalcharacter: 1000,
          follow_date: today,
          display_notes: [],
          loading: false,
        }
      },
      components: {
        DeleteModal,
        ValidationModal,
        DatePicker
      },
      methods: {
        createdDate(value) {
          return moment(String(value)).utc().format('MMM D, YYYY h:mm:ss A')
        },
        FollowDate(value) {
          return moment(String(value)).utc().format('ddd. MMM. D, YYYY - h:mm A')
        },
        charCount: function() {
          this.totalcharacter = parseInt(1000) - parseInt(this.notes.length);
        },
        notBeforeToday(date) {
          return date < today;
        },
        saveNotes: function() {
          if(this.accountId > 0) {
            this.$validator.resume();
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                const followDateStr = moment(this.follow_date).format('YYYY-MM-DD HH:mm:ss')
                axios('/notes',
                 {
                   method: 'POST',
                   data:
                    {
                      notes: this.notes,
                      status: 'PENDING',
                      follow_up_reason: this.follow_reason,
                      date: followDateStr,
                      time_hours: this.time_hours,
                      time_minutes: this.time_minutes,
                      session: this.session,
                      account_id: this.accountId,
                    },
                 }
                )
                .then((resp) => {
                  this.notes = '';
                  this.follow_reason = '';
                  this.follow_date = today;
                  this.time_hours = '09';
                  this.time_minutes = '00';
                  this.session = 'AM';
                  this.totalcharacter = 1000;
                  this.$validator.pause();
                  this.loadNotesAction();
                })
                .catch(error => {
                });
              }
            })
            .catch(() => {

            });
          }

        },
        updateNotes: function(note_id) {
          axios('/notes/' + note_id,
           {
             method: 'PATCH',
             data:
              {
                status: 'COMPLETED',
              },
           }
          )
          .then((resp) => {
            this.notes = '';
            this.follow_reason = '';
            this.follow_date = today;
            this.time_hours = '09';
            this.time_minutes = '00';
            this.session = 'AM';
            this.totalcharacter = 1000;
            this.loadNotesAction();
          })
          .catch(error => {
          });
        },
        loadNotesAction: function() {
          this.loading = true;
          axios("/notes", {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          })
          .then(response => {
            this.loading = false;
            this.display_notes = response.data;
          })
          .catch(error => {

          });

        },
        print_router_redirect: function() {
          let routeData = this.$router.resolve({name: 'enterpriselookupnotesprintout', params: {account_id: this.accountId}});
          window.open(routeData.href, '_blank');
        },
      },
      created: function () {
        if(this.accountId > 0) {
          this.loadNotesAction();
        }
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
    }
</script>

<style scoped>
.button-width {
  width: 100px;
}
.notes_textarea {
  height: 100px;
}
label {
  font-weight: bold;
}
.mx-datepicker {
  width: 100%;
}
hr {
  border-top: 2px solid #4c94cf;
  margin-top: 5px;
  margin-bottom: 10px;
}
.notes {
  height: 350px;
  overflow-x: scroll;
}
.mx-datepicker-popup {
  position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_notes_tab.vue